<style lang="scss">
  /* Styles are handled by the SingleSelectDropdown component */
</style>

<script>
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import { kindStore } from "../stores";

  // User type options for outreach License
  const userTypeOptions = [
    {
      id: "user",
      label: "User",
      description:
        "Can create and manage email campaigns, manage contacts, and use all outreach features",
    },
    {
      id: "superUser",
      label: "Super-User",
      description:
        "All outreach capabilities of a user, plus the ability to edit teammate's campaigns and send from their accounts",
    },
    {
      id: "viewer",
      label: "Viewer",
      description:
        "Can see everything a user can see, but can't make any changes.",
    },
    {
      id: "alias",
      label: "Alias",
      description:
        "An account from which another account can send emails. Cannot access SourceWhale itself.",
    },
  ];
</script>

<SingleSelectDropdown
  label="User Type"
  items={userTypeOptions}
  bind:selected={$kindStore}
  showDescription={true}
  listDescriptionStyle="max-width: 100%;"
/>
